import React, { Component } from "react";
import { Button, Wrapper, Title, Copy } from "app/NativeComponents/common";

import { store } from "app/store";

class HandleView extends Component {
  renderInnerHandle() {
    if (!!this.props.title) {
      return (
        <Wrapper
          style={{
            flex: 1
          }}
        >
          <Title>{this.props.title}</Title>
          <Copy
            style={{
              opacity: this.props.subtitle !== "" && this.props.subtitle ? 1 : 0
            }}
          >
            {this.props.panel_open ? "" : this.props.subtitle}
          </Copy>
        </Wrapper>
      );
    }
    if (this.props.handleComponent) {
      return this.props.handleComponent();
    }
  }
  render() {
    return (
      <Button
        noFeedback
        onPress={this.props.onPress}
        style={{
          height: 85,
          backgroundColor: this.props.colors.background_color,
          borderTopRightRadius: 20,
          borderTopLeftRadius: 20
        }}
      >
        <Wrapper
          style={{
            padding: 10,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Wrapper
            style={{
              height: 8,
              width: 60,
              borderRadius: 4,
              backgroundColor: this.props.colors.gray_color
            }}
          />
        </Wrapper>
        <Wrapper
          style={{
            height: 40,
            //padding: 20,
            paddingTop: 0,
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          {this.renderInnerHandle()}
        </Wrapper>

        <Wrapper
          style={{ height: 20, backgroundColor: this.props.colors.card_color }}
        />
      </Button>
    );
  }
}

export default HandleView;
